import type React from "react";

import styled from "styled-components";

import type { IChipItemProps } from "@similarweb/ui-components";
import { SimpleChipItem } from "@similarweb/ui-components";

const FullClickSimpleChipItem: React.FunctionComponent<IChipItemProps> = ({ onCloseItem, ...rest }) => {
    return (
        <SimpleChipItem
            onCloseItem={onCloseItem}
            // @ts-ignore FIXME: strict migration - onCloseItem (required MouseEvent param) not assignable to onClick (optional param) — IChipItemProps types from @similarweb/ui-components, can't widen
            onClick={onCloseItem}
            {...rest}
        />
    );
};

export const AddStringChip = styled(FullClickSimpleChipItem)`
    cursor: pointer;

    & svg {
        transform: rotate(45deg);
    }

    .ChipItemText {
        max-width: 200px;
    }
`;
AddStringChip.displayName = "AddStringChip";
